export default {
  getpulldownlist: '/seo/sites', // 网站下拉列表
  addseoweb: '/seo/sites/', // 添加seo网站
  getboardlist: '/seo/sites/list/', // 看板分页列表
  getwebsitedetail: '/seo/sites/', // seo网站详情
  setwebsiteup: '/seo/sites/', // seo网站修改
  optimizeKeywordList: '/seo/keywords/list/', // 关键词分页列表
  keywordstati: '/seo/keywords/statistics/', // 关键词统计
  languageList: '/admin/language', //语言列表
  queryGeotargets: '/admin/geotargets/{condition}', //地理位置查询
  keywordReport: '/admin/keyword/report', //关键字报告
  seoarticlelist: '/article/articlepage/', // seo文章列表
  seoarticledetail: '/article/articledetail/', // seo文章详情
  articleuseswitch: '/article/articleuseswitch/', // 文章是否使用
  setarticlevalid: '/article/putintoeffect/', // 文章设为有效
  keywordLists: '/seo/keywords/idea/list', // 关键词列表
  addoptimize: '/seo/keywords', // 添加优化
  deloptimize: '/seo/keywords', // 删除优化
  compiletitle: '/article/titleedit', // 编辑标题
  savearticle: '/article/articlesave', // 保存文章
  translation: '/article/translatearticle/' // 文章翻译
}
